import { useEffect, useState } from "react";
import { ArrowUp} from "lucide-react";

const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 100) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    visible && (
      <button
        onClick={scrollToTop}
       className={`fixed bottom-[90px] right-8 transition-opacity duration-300 
        ${visible ? "opacity-100" : "opacity-0"} 
        bg-orange-500 hover:bg-orange-600 text-white p-3 rounded-full shadow-lg z-40`}
      >
        <ArrowUp   size={18} />
      </button>
    )
  );
};

export default ScrollToTopButton;